import React, { useEffect, useState } from 'react'
import LopBanDoApi from '../../api/LopBanDoApi';
import ol from "openlayers";
import "ol/ol.css";
import { SelectHuyen } from '../../shared/selecthuyen/SelectHuyen';
import ThongBao from '../../core/ThongBao';
import BanDoThichHopApi from '../../api/BanDoThichHopApi';
import { ModalEditThongTin } from './ModalEditThongTin';
import LopMauApi from '../../api/LopMauApi';
import Authen from '../../core/Authen';
import madontinh from '../../main/madontinh/madontinh'

export const BanDoMucDoThichHop = () => {
    const view = new ol.View({
        center: [11725287.264889468, 2355407.026607706],
        zoom: 11
    });
    const kieuBanDo = 4;

    var [map, setMap] = useState(new ol.Map());
    // var map;
    const [listLopBanDos, setLopBanDo] = useState([]);
    var [thongTin, setThongTin] = useState({});
    var [provinceDat, setDat] = useState(new ol.layer.Vector());
    var [sourceDat, setSourcDat] = useState(new ol.source.Vector());
    var [selectDat, setSelectDat] = useState(null);
    const [flagAddEdit, setFlagAddEdit] = useState(0);
    const [draw, setdraw] = useState(null);
    const [IdHuyen, setIdHuyen] = useState(0);
    const [flagEdit, setFlagEdit] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    var [listStyles, setListStyle] = useState([]);
    const [isThemMoi, setThemMoi] = useState(true);

    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);
    const [dvt,setDVT] = useState([]);

    const style = (color, text) => {
        return new ol.style.Style({
            fill: new ol.style.Fill({
                color: color,
            }),
            stroke: new ol.style.Stroke({
                color: '#C0C0C0',
            }),
            text: new ol.style.Text({
                text: text,
                fill: new ol.style.Fill({
                    color: "#040482"
                })
            })
        });
    }

    const stylefunction = function (feature, resolution) {
        let madat = feature.get('tnh');
        let index = listStyles.findIndex(x => x.MaMau === madat);
        let text = ''
        if (resolution < 10) {
            text = madat;
        }
        if (index !== -1) {
            return style(listStyles[index].MauSac, text);
        }
        else {
            return style("rgb(37 98 236 / 50%)", '');
        }
    }

    const highlightStyle = new ol.style.Style({
        fill: new ol.style.Fill({
            color: 'rgb(37 98 236 / 50%)',
        }),
        stroke: new ol.style.Stroke({
            color: '#5782ff',
            width: 1,
        }),
    });

    const clickEdit = () => {
        if (flagAddEdit === 2) {
            setFlagAddEdit(0);
            map.getInteractions().forEach(item => {
                map.removeInteraction(item);
            })
        }
        else {
            setFlagAddEdit(2);
            let select = new ol.interaction.Select({ wrapX: false, });
            let modify = new ol.interaction.Modify({ features: select.getFeatures(), });
            map.getInteractions().extend([select, modify]);
            var selected_features = select.getFeatures();
            var dirty = {};
            selected_features.on('add', function (evt) {
                var feature = evt.element;
                var fid = feature.getId();
                feature.on('change', function (evt) {
                    dirty[fid] = true;
                });
            });

            selected_features.on('remove', function (evt) {
                var feature = evt.element;
                var fid = feature.getId();
                if (dirty[fid]) {
                    ThongBao.printConfirmationDialog("Bạn có muốn cập nhật sử thay đổi này không?", () => {
                        var geoJson = new ol.format.WKT();
                        var geoText = geoJson.writeGeometry(feature.getGeometry());
                        thongTin.Geometry = geoText;
                        setThongTin(thongTin);
                        setThemMoi(false);
                        setShowEdit(true);
                        // BanDoThichHopApi.updateGeo(data).then(() => {
                        //     ThongBao.printSuccessMessage("Cập nhật thành công!");
                        // });
                    }, () => {
                        provinceDat.getSource().clear();
                    });
                }
            });


            setMap(map);
        }
    }

    const clickAdd = () => {
        // console.log(draw);
        if (flagAddEdit === 0) {
            setFlagAddEdit(1);
            map.addInteraction(draw);
        }
        else {
            map.removeInteraction(draw);
            setFlagAddEdit(0);
        }
        setMap(map);
    }

    const loadLopBanDo = async (idhuyen) => {
        let params = {
            _tyle: kieuBanDo
        }
        listStyles = await LopMauApi.getLopBanDo(params);
        setListStyle(listStyles);
        params = {
            kieuBanDo: kieuBanDo,
            idHuyen: idhuyen
        }

        const list = await LopBanDoApi.getLopBanDo(params);
        list.forEach(item => {
            if (item.Type === 1 || (item.Type === kieuBanDo && item.GeoJson !== true)) {
                let province = new ol.layer.Image({
                    source: new ol.source.ImageWMS({
                        url: item.Url,
                        params: { layers: item.LayerName, version: item.Version },
                        serverType: "geoserver",
                        ratio: item.Ratio,
                    })
                });
                province.setVisible(item.Checked);
                map.addLayer(province);
                item.province = province;
            }
            else if (item.Type === kieuBanDo && item.GeoJson ===  true) {
                sourceDat = new ol.source.Vector({
                    format: new ol.format.GeoJSON(),
                    url: item.Url
                })
                provinceDat = new ol.layer.Vector({
                    source: sourceDat,
                    style: stylefunction
                })

                function addInteractions() {
                    var flagHtml = document.getElementById('btnAdd').getAttribute('flagadd');
                    var drawNew = new ol.interaction.Draw({
                        source: sourceDat,
                        type: "Polygon",
                        style: new ol.style.Style({
                            fill: new ol.style.Fill({
                                color: '#224abe'
                            }),
                            stroke: new ol.style.Stroke({
                                color: '#224abe',
                            }),
                            image: new ol.style.Circle({
                                radius: 3,
                                fill: new ol.style.Fill({
                                    color: "#224abe",
                                }),
                            })
                        })
                    });
                    setdraw(drawNew);
                    if (flagHtml === "1") {
                        map.addInteraction(drawNew);
                    }
                }
                provinceDat.setVisible(item.Checked);
                map.addLayer(provinceDat);
                item.province = provinceDat;
                setDat(provinceDat);
                setSourcDat(sourceDat);
                addInteractions();
                provinceDat.getSource().on('addfeature', function (event) {
                    var ev = document.getElementById('btnAdd');
                    var flagHtml = 0;
                    if (ev != null) {
                        flagHtml = ev.getAttribute('flagadd');
                    }
                    if (flagHtml === "1" && event.feature.getId() == null) {
                        ThongBao.printConfirmationDialog("Bạn có muốn thêm khoảng đất này không?", () => {
                            var feature = event.feature;
                            var geoJson = new ol.format.WKT();
                            var geoText = geoJson.writeGeometry(feature.getGeometry());
                            thongTin = {};
                            thongTin.geometry = geoText;
                            thongTin.gid = provinceDat.getSource().getFeatures()[0].getId();
                            setThongTin({...thongTin});
                            console.log(thongTin);
                            setThemMoi(true);
                            setShowEdit(true);
                        }, () => {
                            provinceDat.getSource().removeFeature(event.feature);
                            // provinceDat.getSource().clear();
                        });
                    }
                })
            }

        });
        setLopBanDo(list);
        setMap(map);
    }
    useEffect(() => {
        setRoleAdd(Authen.checkQuyen('BDMUCDOTHICHHOP_CREATE'));
        setRoleEdit(Authen.checkQuyen('BDMUCDOTHICHHOP_UPDATE'));
        setRoleDel(Authen.checkQuyen('BDMUCDOTHICHHOP_DELETE'));
        map = new ol.Map({
            target: "map",
            controls: new ol.control.defaults().extend([
                new ol.control.ScaleLine({
                    units: 'metric'
                }),
                new ol.control.FullScreen(),
                new ol.control.ZoomSlider()
            ]),
            layers: [
                // new ol.layer.Tile({
                //     source: new ol.source.OSM(),
                // }),
            ],
            view: view
        });

        map.on('click', function (evt) {
            setFlagEdit(false);
            var flagHtml = document.getElementById('btnEdit').getAttribute('flagedit');
            if (flagHtml === "1") {
                if (selectDat !== null) {
                    selectDat.setStyle(stylefunction);
                    selectDat = null;
                    setSelectDat(selectDat);
                }
                return;
            }
            if (selectDat !== null) {
                selectDat.setStyle(stylefunction);
                setSelectDat(selectDat);
                setThongTin({ ...{} });
            }
            map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                // console.log(feature);
                feature.setStyle(highlightStyle);
                if (feature != null) {
                    let thongTinNew = {};
                    thongTinNew.gid = feature.getId();
                    thongTinNew.ba_kich = feature.get('ba_kich');
                    thongTinNew.bi_xanh = feature.get('bi_xanh');
                    thongTinNew.bo_khai = feature.get('bo_khai');
                    thongTinNew.buoi = feature.get('buoi');
                    thongTinNew.ca_gaileo = feature.get('ca_gaileo');
                    thongTinNew.cam = feature.get('cam');
                    thongTinNew.cat = feature.get('cat');
                    thongTinNew.caytrong = feature.get('caytrong');
                    thongTinNew.cec = feature.get('cec');
                    thongTinNew.chisokhoha = feature.get('chisokhoha');
                    thongTinNew.chum_ngay = feature.get('chum_ngay');
                    thongTinNew.code_qh = feature.get('code_qh');
                    thongTinNew.dalan = feature.get('dalan');
                    thongTinNew.dhtd = feature.get('dhtd');
                    thongTinNew.dt = feature.get('dt');
                    thongTinNew.dt_bs = feature.get('dt_bs');
                    thongTinNew.dua_hau = feature.get('dua_hau');
                    thongTinNew.dungtrong = feature.get('dungtrong');
                    thongTinNew.dungtrong_ = feature.get('dungtrong_');
                    thongTinNew.dvdd = feature.get('dvdd');
                    thongTinNew.g = feature.get('g');
                    thongTinNew.ht_qh = feature.get('ht_qh');
                    thongTinNew.huyen = feature.get('huyen');
                    thongTinNew.id = feature.get('id');
                    thongTinNew.k2o = feature.get('k2o');
                    thongTinNew.keo = feature.get('keo');
                    thongTinNew.khoai_so = feature.get('khoai_so');
                    thongTinNew.khohan_dt = feature.get('khohan_dt');
                    thongTinNew.khoi_tu = feature.get('khoi_tu');
                    thongTinNew.khoi_tu = feature.get('khoi_tu');
                    thongTinNew.lac = feature.get('lac');
                    thongTinNew.lua = feature.get('lua');
                    thongTinNew.luongmua_d = feature.get('luongmua_d');
                    thongTinNew.ma_congtua = feature.get('ma_congtua');
                    thongTinNew.ma_dexuat = feature.get('ma_dexuat');
                    thongTinNew.madat = feature.get('madat');
                    thongTinNew.mang_tay = feature.get('mang_tay');
                    thongTinNew.mau_anhhuo = feature.get('mau_anhhuo');
                    thongTinNew.mia = feature.get('mia');
                    thongTinNew.mit = feature.get('mit');
                    thongTinNew.n = feature.get('n');
                    thongTinNew.ngapung_dt = feature.get('ngapung_dt');
                    thongTinNew.ngo = feature.get('ngo');
                    thongTinNew.nhan = feature.get('nhan');
                    thongTinNew.nhietdo = feature.get('nhietdo');
                    thongTinNew.oc = feature.get('oc');
                    thongTinNew.oi = feature.get('oi');
                    thongTinNew.om = feature.get('om');
                    thongTinNew.p2o5 = feature.get('p2o5');
                    thongTinNew.pc_cec = feature.get('pc_cec');
                    thongTinNew.pc_chisokh = feature.get('pc_chisokh');
                    thongTinNew.pc_dd = feature.get('pc_dd');
                    thongTinNew.pc_dp = feature.get('pc_dp');
                    thongTinNew.pc_k = feature.get('pc_k');
                    thongTinNew.pc_n = feature.get('pc_n');
                    thongTinNew.pc_om = feature.get('pc_om');
                    thongTinNew.pc_p = feature.get('pc_p');
                    thongTinNew.pc_ph = feature.get('pc_ph');
                    thongTinNew.pthongTinNewc_r = feature.get('pc_r');
                    thongTinNew.pc_t = feature.get('pc_t');
                    thongTinNew.phanvung = feature.get('phanvung');
                    thongTinNew.phkcl = feature.get('phkcl');
                    thongTinNew.qh_qh = feature.get('qh_qh');
                    thongTinNew.rau = feature.get('rau');
                    thongTinNew.thongTinNewsa = feature.get('sa');
                    thongTinNew.sam_day = feature.get('sam_day');
                    thongTinNew.san = feature.get('san');
                    thongTinNew.set = feature.get('set');
                    thongTinNew.sl = feature.get('sl');
                    thongTinNew.sothangkho = feature.get('sothangkho');
                    thongTinNew.symbol_qh = feature.get('symbol_qh');
                    thongTinNew.tangday = feature.get('tangday');
                    thongTinNew.tenpd = feature.get('tenpd');
                    thongTinNew.thit = feature.get('thit');
                    thongTinNew.tieu_dt = feature.get('tieu_dt');
                    thongTinNew.tinh = feature.get('tinh');
                    thongTinNew.tn = feature.get('tn');
                    thongTinNew.tpcg = feature.get('tpcg');
                    thongTinNew.truongnhan = feature.get('truongnhan');
                    thongTinNew.tton_dt = feature.get('tton_dt');
                    thongTinNew.tuoi_dt = feature.get('tuoi_dt');
                    thongTinNew.xa = feature.get('xa');

                    thongTinNew.khoai=feature.get('khoai');
                    thongTinNew.quyt=feature.get('quyt');
                    thongTinNew.na=feature.get('na');
                    thongTinNew.xoai=feature.get('xoai');
                    thongTinNew.che=feature.get('che');
                    thongTinNew.chanh=feature.get('chanh');
                    thongTinNew.ca_gai_leo=feature.get('ca_gai_leo');
                    thongTinNew.ca_phe_che=feature.get('ca_phe_che');
                    thongTinNew.dau_tuong=feature.get('dau_tuong');
                    thongTinNew.dau_tam=feature.get('dau_tam');

                    thongTinNew.tnh = feature.get('tnh');
                    thongTinNew.dvddh = feature.get('dvddh');

                    setThongTin(thongTinNew);
                    selectDat = feature;
                    setSelectDat(selectDat);
                    setFlagEdit(true);
                    donVT(thongTin);
                }
                else {
                    setThongTin({ ...{} });
                }
            });
        });
        // setMap(map);

    }, []);


    const donVT = (value) =>{
        const donvitinh = [
            {Ma:'Fe',Value:value.fe,Ten:''},
            {Ma:'Sl',Value:value.sl,Ten:''},
            {Ma:'Gv',Value:value.dalan,Ten:''},
            {Ma:'De',Value:value.de,Ten:''},
            {Ma:'Ir',Value:value.tuoi_dt,Ten:''},
            {Ma:'Tx',Value:value.tpcg,Ten:''}
        ]
        setDVT(madontinh.getTen(donvitinh));
    }

    const getIdHuyen = (event) => {
        if (event.value !== 0 && event.value !== IdHuyen) {
            listLopBanDos.forEach(item => {
                map.removeLayer(item.province);
            })
            setIdHuyen(event.value)
            map.setView(new ol.View({
                center: [event.toaDoX, event.toaDoY],
                zoom: event.zoom
            }));
            loadLopBanDo(event.value);
        }
    }

    const checkBoHandler = () => { };

    const clickRow = (id) => {
        listLopBanDos.forEach(item => {
            if (item.Id === id) {
                item.Checked = !item.Checked;
                map.getLayers().forEach(l => {
                    if (l === item.province) {
                        l.setVisible(item.Checked);
                    }
                })
            }
        });
        setLopBanDo([...listLopBanDos]);
        setDat(map);
    }

    const delFeature = () => {
        ThongBao.printConfirmationDialog("Bạn có muốn xóa khoảng đất đã chọn đi không?", () => {
            BanDoThichHopApi.delete(thongTin.gid).then(() => {
                provinceDat.getSource().removeFeature(selectDat);
                ThongBao.printSuccessMessage("Xóa khoảnh đất thành công!");
            });
        });
        // ThongBao.printSuccessMessage('OK');
    }

    const clickEditThongTin = () => {
        // console.log(thongTin);
        setShowEdit(true);
        setThemMoi(false);
    }

    const closeThongTin = () => {
        setShowEdit(false);

    }

    const saveSuccess = () => {
        setShowEdit(false);
        provinceDat.getSource().clear();
    }

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h5 className="m-0 text-primary">Bản đồ mức độ thích hợp sử dụng đất</h5>
                </div>
                <div className="col-md-4">
                    <SelectHuyen onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyen>
                </div>
                {/* <div className="input-group col-md-3">
                    <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                    <div className="input-group-append">
                        <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                    </div>
                </div> */}
                <div className="col-md-4 bd-button text-right">
                    {roleEdit == true ?<button id="btnEditThongTin" type="button" className="btn btn-primary btn-sm" disabled={!flagEdit} onClick={clickEditThongTin}><i className='far fa-edit'></i> Sửa TT </button>: ''}
                    {roleAdd == true ?<button id="btnAdd" disabled={flagAddEdit === 2} type="button" className="btn btn-success btn-sm" onClick={clickAdd} flagadd={flagAddEdit}><i className='fas fa-plus' hidden={flagAddEdit === 1 ? true : false}></i> {flagAddEdit === 1 ? 'Đóng' : 'Thêm'}</button>: ''}
                    {roleEdit == true ?<button id="btnEdit" disabled={flagAddEdit === 1} type="button" className="btn btn-primary btn-sm" onClick={clickEdit} flagedit={flagAddEdit}><i className='fas fa-edit' hidden={flagAddEdit === 2 ? true : false}></i> {flagAddEdit === 2 ? 'Đóng' : 'Sửa'}</button>: ''}
                    {roleDel == true ?<button type="button" disabled={flagAddEdit !== 0} className="btn btn-danger btn-sm" onClick={delFeature}><i className='fas fa-trash-alt'></i></button>: ''}
                </div>
            </div>
            <div className="card-body">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-9 ban-do" id="map">

                        </div>
                        <div className="col-md-3 list-lop">
                            <div className="row lop-ban-do">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th className="col-checkbox"></th>
                                            <th>Lớp bản đồ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            listLopBanDos.map((item, key) => {
                                                return (
                                                    <tr onClick={() => clickRow(item.Id)} key={key}>
                                                        <td className="col-checkbox">
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={checkBoHandler} />
                                                            </div>
                                                        </td>
                                                        <td>{item.Name}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="row thong-tin">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th className="col-name">Tên</th>
                                            <th>Thông tin</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="col-name">Tỉnh</td>
                                            <td>{thongTin.tinh}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Huyện</td>
                                            <td>{thongTin.huyen}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Xã</td>
                                            <td>{thongTin.xa}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Diện tích</td>
                                            <td>{thongTin.dt_bs}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Mã đất</td>
                                            <td>{thongTin.madat}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân vùng</td>
                                            <td>{thongTin.phanvung}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Loại đất</td>
                                            <td>{thongTin.g}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Địa hình tương đối</td>
                                            <td>{thongTin.dhtd}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Địa hình</td>
                                            <td>{dvt.filter(x=>x.Ma==='Sl' && x.Value ===thongTin.sl).map(x =>  x.Ten)}</td>
                                        <td></td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Tầng dày</td>
                                            <td><td>{dvt.filter(x=>x.Ma==='De' && x.Value ===thongTin.tangday).map(x =>  x.Ten)}</td></td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Thành phần cơ giới</td>
                                            <td><td>{dvt.filter(x=>x.Ma==='Tx' && x.Value ===thongTin.tpcg).map(x =>  x.Ten)}</td></td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Mức độ Đá lẫn</td>
                                            <td><td>{dvt.filter(x=>x.Ma==='Gv' && x.Value ===thongTin.dalan).map(x =>  x.Ten)}</td></td>
                                        </tr>
                                        {/* <tr>
                                            <td className="col-name">Dung trọng</td>
                                            <td>{thongTin.dungtrong}</td>
                                        </tr> */}
                                        <tr>
                                            <td className="col-name">Phân Cấp PH</td>
                                            <td>{thongTin.pc_ph}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp CEC</td>
                                            <td>{thongTin.pc_cec}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp dinh dưỡng</td>
                                            <td>{thongTin.pc_dd}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp nito</td>
                                            <td>{thongTin.pc_n}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp phốt pho</td>
                                            <td>{thongTin.pc_p}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp Kali</td>
                                            <td>{thongTin.pc_k}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp chất hữu cơ</td>
                                            <td>{thongTin.pc_om}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp độ phì</td>
                                            <td><td>{dvt.filter(x=>x.Ma==='Fe' && x.Value ===thongTin.pc_dp).map(x =>  x.Ten)}</td></td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Lượng mưa</td>
                                            <td>{thongTin.luongmua_d}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Tổng tích ôn</td>
                                            <td>{thongTin.tton_dt}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Mức độ khô hạn</td>
                                            <td>{thongTin.khohan_dt}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Nhiệt đô</td>
                                            <td>{thongTin.nhietdo}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Chỉ số khô hạn</td>
                                            <td>{thongTin.chisokhoha}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Phân cấp chỉ số khô hạn</td>
                                            <td>{thongTin.pc_chisokh}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Số tháng khô hạn</td>
                                            <td>{thongTin.sothangkho}</td>
                                        </tr>                                        
                                        <tr>
                                            <td className="col-name">Cây trồng</td>
                                            <td>{thongTin.caytrong}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Ngập úng</td>
                                            <td>{thongTin.ngapung_dt}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Chế độ tưới</td>
                                            <td> <td>{dvt.filter(x=>x.Ma==='Ir' && x.Value ===thongTin.tuoi_dt).map(x =>  x.Ten)}</td></td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Chế độ tiêu</td>
                                            <td>{thongTin.tieu_dt}</td>
                                        </tr>

                                        <tr>
                                            <td className="col-name">DungTrong_</td>
                                            <td>{thongTin.dungtrong_}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Mau_AnhHuong</td>
                                            <td>{thongTin.mau_anhhuo}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">dvdd</td>
                                            <td>{thongTin.dvdd}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">dvddh</td>
                                            <td>{thongTin.dvddh}</td>
                                        </tr>

                                        <tr>
                                            <td className="col-name">Lúa</td>
                                            <td>{thongTin.lua}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Ngô</td>
                                            <td>{thongTin.ngo}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Rau</td>
                                            <td>{thongTin.rau}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Khoai</td>
                                            <td>{thongTin.khoai}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Sắn</td>
                                            <td>{thongTin.san}</td>
                                        </tr>

                                        <tr>
                                            <td className="col-name">Lạc</td>
                                            <td>{thongTin.lac}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Mía</td>
                                            <td>{thongTin.mia}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Cam</td>
                                            <td>{thongTin.cam}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Quýt</td>
                                            <td>{thongTin.quyt}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Bưởi</td>
                                            <td>{thongTin.buoi}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Chè</td>
                                            <td>{thongTin.che}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Dưa hấu</td>
                                            <td>{thongTin.dua_hau}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Na</td>
                                            <td>{thongTin.na}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Chanh</td>
                                            <td>{thongTin.chanh}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Xoài</td>
                                            <td>{thongTin.xoai}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Cà gai leo</td>
                                            <td>{thongTin.ca_gai_leo}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Dâu tằm</td>
                                            <td>{thongTin.dau_tam}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Nhãn</td>
                                            <td>{thongTin.nhan}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Cà phê chè</td>
                                            <td>{thongTin.ca_phe_che}</td>
                                        </tr>
                                        <tr>
                                            <td className="col-name">Đậu tương</td>
                                            <td>{thongTin.dau_tuong}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalEditThongTin showEdit={showEdit} thongTin={thongTin} closeThongTin={closeThongTin} themMoi={isThemMoi} saveSuccess={saveSuccess}></ModalEditThongTin>
        </div>
    )
}
